<template>
  <CoachShell>
    <Requests></Requests>
  </CoachShell>

</template>

<script>

import Requests from "./Requests";
import CoachShell from "../coaches/CoachShell";

export default {
  name: "RequestsReceived",
  components: {
    Requests,
    CoachShell
  },
}
</script>
